import React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import { RenderErrorMessage } from './RenderErrorMessage'

interface Props {
    deps: CommonDeps
    children: React.ReactNode
    fallback?: React.ReactNode
}
export default class ErrorBoundary extends React.Component<Props, { hasError: boolean }> {
    public state = {
        hasError: false,
    }

    public static getDerivedStateFromError() {
        return { hasError: true }
    }

    public render() {
        if (this.state.hasError) {
            if (this.props.fallback !== undefined) return this.props.fallback
            return (
                <RenderErrorMessage
                    getImage={this.props.deps.getImage}
                    language={this.props.deps.language}
                    triggerSentryReplay={this.props.deps.triggerSentryReplay}
                />
            )
        }
        return this.props.children ?? null
    }
}
